import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa";
import './CarouselPage.css';

function CarouselPage() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="carousel-wrapper">
        <Carousel interval={null}>
          <Carousel.Item>
            <img className="carousel-image desktop" src="./images/XR_walkthrough_DT.webp" alt="XR_walkthrough" onClick={() => navigate('/products/spatialcatalogue')} />
            <img className="carousel-image mobile" src="./images/XR_walkthrough_l.webp" alt="XR_walkthrough" onClick={() => navigate('/products/spatialcatalogue')} />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="carousel-image desktop clickable"
              src="./images/XR_workshop_DT.webp"
              alt="XR_workshop"
              onClick={() => navigate('/products/spatialcatalogue')}
            />
            <img
              className="carousel-image mobile clickable"
              src="./images/XR_workshop_l.webp"
              alt="XR_workshop"
              onClick={() => navigate('/products/spatialcatalogue')}
            />
          </Carousel.Item>
          <Carousel.Item>
            <img className="carousel-image desktop" src="./images/XR_training_DT.webp" alt="HandsOnTraining" />
            <img className="carousel-image mobile" src="./images/XR_training_l.webp" alt="HandsOnTraining" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="carousel-image desktop" src="./images/XR_remote_DT.webp" alt="XR_realtimecollaboration" />
            <img className="carousel-image mobile" src="./images/XR_remote_l.webp" alt="XR_realtimecollaboration" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="carousel-image desktop" src="./images/XR_monitor_DT.webp" alt="XR_monitor" />
            <img className="carousel-image mobile" src="./images/XR_monitor_l.webp" alt="XR_monitor" />
          </Carousel.Item>
        </Carousel>
        <div className="button-container">
          {/* <p>Click</p> */}
          <button className="highlight-button" onClick={() => navigate('/products/spatialcatalogue')}>
            <span className="btn-spatial">Spatial</span>
            <span className="btn-divider">|</span>
            <span className="btn-catalogue">Catalogue </span>
            <FaArrowRight className="btn-arrow" />
          </button>
        </div>
      </div>

      <div className="who-we-are">
        <h2 className="offer-title">Who we are</h2>
        <div className="underline"></div>
        <strong className="companytitle">
          <b>Spatial Computing Technologies Pvt. Ltd.</b>
        </strong>
        <br />
        <strong className="title2">
          <b className="companytitle">(SpatialCT)</b> – a DeepTech startup
        </strong>
        <div className="question">
          Helping businesses step confidently into the <b>AI</b>-driven Spatial Computing Era <b>(AR | VR | MR)</b> – just like they once embraced Desktop and Mobile Computing.
        </div>

        <p className="question">- That’s what we’re all about.</p>

        <div className='questions'>

          At SpatialCT, we believe that spatial computing represents the next major leap in human-computer interaction—one as transformative as the shifts brought about by desktop and mobile computing in previous decades. Our mission is to help businesses of all sizes harness this evolution, not only by adopting immersive technologies but by doing so with strategic clarity, technical precision, and measurable impact.

        </div>
        {/* <div className='questions'>
          
Whether it's enhancing operational efficiency, transforming customer engagement, enabling remote collaboration, or upskilling the workforce, our solutions are designed to create meaningful value in a wide range of industries—from manufacturing and education to healthcare and government services. Backed by decades of experience in 3D graphics, gaming, and XR, we deliver services and platforms that blend creativity with engineering rigor.

        </div>
        <div className='questions'>

SpatialCT is more than a technology provider—we are your innovation partner. We walk with you every step of the way as you explore, adapt, and thrive in the immersive digital future.

        </div> */}
        <div className="catalogue-dpiit-recognition">
          <img src="/images/Dpiit_Logo.webp" alt="DPIIT Recognised Innovation" className="dpiit-logo" />
          <span className="dpiit-text">DPIIT Recognised Innovation (Govt. of India)</span>
          <span className="dpiit-text">Certificate number (DIPP240680)</span>
        </div>

      </div>

    </div>

  );
}

export default CarouselPage;